import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useDashboardFilters = () => {
  const [searchParams] = useSearchParams();
  const location = searchParams.get("location") || undefined;
  const userId = searchParams.get("userId") || undefined;

  return useMemo(() => {
    const cleanedLocation =
      !location || location === "All" ? undefined : location;
    const cleanedUserId =
      !userId || userId === "all" ? undefined : userId;
    return { location: cleanedLocation, userId: cleanedUserId };
  }, [location, userId]);
};
